import { Box, Grid, Table, TableCell, TableRow } from '@mui/material';
import React from 'react';
import { getTipoSangre } from '../../../../widgets/fields/TiposSangreField';
import CodeQrComponent from './code_qr';

const ExpandeUsuEntidades = ({ data }) => {
  return (
    data && (
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={2} sx={{ p: 1 }}>
          <Grid item xs={12} md={3}>
            {data.usuario.codeqr && (
              <CodeQrComponent
                size={100}
                maxWidth={100}
                value={data.usuario.codeqr}
                download
                id={`${data.usuario.perfil.pnombre}-${data.usuario.perfil.papellido}`}
              />
            )}
          </Grid>
          <Grid item xs={12} md={9}>
            <Table width="100%">
              <TableRow>
                <TableCell>
                  <strong>Fecha de nacimiento:</strong>
                  <br />
                  {data.usuario.perfil.fechaNacimiento}
                </TableCell>
                <TableCell>
                  <strong>Tipo de sangre:</strong>
                  <br />
                  {getTipoSangre(data.usuario.perfil.tipoSangre)}
                </TableCell>
                <TableCell>
                  <strong>Tiene internet:</strong>
                  <br />
                  {data.usuario.perfil.internet ? 'Si' : 'No'}
                </TableCell>
              </TableRow>
            </Table>
          </Grid>
        </Grid>
      </Box>
    )
  );
};

export default ExpandeUsuEntidades;
